import Vue from "vue";
import VueI18n from "vue-i18n";
import messagesPL from "@/i18n/pl";

Vue.use(VueI18n);

const messages = {
  pl: messagesPL
};
export default new VueI18n({
  locale: process.env.VUE_APP_LANG,
  messages
});
